import { IconButton } from "@mui/material";
import { DataGrid, GridColumns, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { ArrowBackIos as ArrowBackIosIcon, ArrowForwardIos as ArrowForwardIosIcon } from "@mui/icons-material";
import Layout from "components/Layout";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import PortfolioController, { PortfolioTransactionMonth } from "services/controllers/PortfolioController";
import { Colors } from "models/Colors";

const CustomToolbar = (props: any) => {
	const { goBackFunction } = props
	return (
		<GridToolbarContainer>
			<IconButton onClick={goBackFunction} size="large">
				<ArrowBackIosIcon style={{ color: Colors.primary }} />
			</IconButton>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport />
		</GridToolbarContainer>
	);
}
export default function PortfolioMonth(props: { match: { params: { uid: string } } }) {
	const [portfolioMonthList, setPortfolioMonthList] = useState<PortfolioTransactionMonth[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const portfolioController = new PortfolioController()
	const history = useHistory()

	const uid: string = props.match.params.uid
	useEffect(() => {
		const fetchData = () => {
			getPortfolioMonths.current()
		}
		return fetchData()
	}, [])

	const columns: GridColumns = [
		{ field: "month", headerName: "Month", width: 300 },
		{
			field: "View",
			headerName: "View",
			width: 125,
			renderCell: (params: any) => {
				const onClick = () => {
					history.push(`/users/${uid}/portfolio/${params.id}`)
				};
				return (
					<IconButton onClick={onClick} title={"Goals"} size="large">
						<ArrowForwardIosIcon />
					</IconButton>
				);
			}
		},
	]

	const getPortfolioMonths = useRef(() => { })

	getPortfolioMonths.current = async () => {
		portfolioController.getPortfolioMonths(uid, (data) => {
			setPortfolioMonthList(data)
			if (loading)
				setLoading(false)
		})
	}

	return (
		<Layout id={2}>
			<div
				style={{
					height: "calc(100vh - 170px)",
					width: "100%"
				}}>
				<DataGrid
					components={{
						Toolbar: CustomToolbar
					}}
					componentsProps={{
						toolbar: {
							goBackFunction: () => {
								history.push("/users")
							},
						}
					}}
					rows={portfolioMonthList}
					columns={columns}
					loading={loading} />
			</div>
		</Layout>
	)
}
